import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckIcon } from 'lucide-react';
export function ProductRevealSection() {
  const features = ['cómo funcionan los ciclos de sueño de los bebés (y por qué se despiertan)', 'las verdaderas causas de los despertares nocturnos', 'qué son las ventanas de sueño y cómo usarlas correctamente', 'rutinas efectivas por edad (desde recién nacido hasta 3 años)', 'cómo manejar regresiones del sueño sin sentir que vuelves a cero', 'estrategias para reducir despertares nocturnos paso a paso', 'cómo crear un ambiente ideal para dormir', 'cuáles son los errores más comunes que sabotean el sueño (aunque tengas la mejor intención)'];
  return <section className="py-10 md:py-16 px-4 md:px-6" data-id="element-237">
      <div className="max-w-4xl mx-auto" data-id="element-238">
        <FadeIn data-id="element-239">
          <div className="text-center mb-8 md:mb-12" data-id="element-240">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-serif mb-4 md:mb-6 text-balance text-white" data-id="element-241">
              Presento: Guía del Sueño del Bebé{' '}
              <br className="hidden md:block" data-id="element-242" />
              <span className="text-gold italic text-xl md:text-3xl lg:text-4xl" data-id="element-243">
                (0 a 3 Años)
              </span>
            </h2>
            <p className="text-base md:text-xl text-white/70 max-w-2xl mx-auto" data-id="element-244">
              Una guía clara, fácil de aplicar y con base científica para
              entender:
            </p>
          </div>
        </FadeIn>

        <div className="bg-navy-card rounded-2xl md:rounded-3xl p-5 md:p-12 shadow-xl shadow-gold/5 border border-gold/10" data-id="element-245">
          <ul className="space-y-3 md:space-y-5" data-id="element-246">
            {features.map((feature, index) => <FadeIn key={index} delay={index * 0.08} direction="left" data-id="element-247">
                <li className="flex items-start gap-3" data-id="element-248">
                  <div className="mt-0.5 flex-shrink-0 bg-navy-light rounded-full p-1" data-id="element-249">
                    <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-gold" data-id="element-250" />
                  </div>
                  <span className="text-base md:text-lg text-white/80 leading-relaxed" data-id="element-251">
                    {feature}
                  </span>
                </li>
              </FadeIn>)}
          </ul>

          <FadeIn delay={0.8} data-id="element-252">
            <div className="mt-8 md:mt-12 text-center" data-id="element-253">
              <p className="text-xl md:text-2xl font-serif font-bold text-gold" data-id="element-254">
                No son tips sueltos. Es un sistema.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}